<div>
  <kendo-grid [kendoGridBinding]="gridView" [pageable]="true" [pageSize]="state.take" [skip]="state.skip"
    [scrollable]="'true'" [sortable]="true" [resizable]="true" filterable="menu" [filter]="state.filter"
    [sort]="state.sort">
    <!-- DETAIL VIEW -->
    <ng-template kendoGridDetailTemplate let-dataItem>
      <div class="row">
        <div class="col s12 m12 l12 xl12">
          <app-child-detailed-view [data]="dataItem"></app-child-detailed-view>
        </div>
      </div>
    </ng-template>

    <!-- MOBILE VIEW -->
    <kendo-grid-column media="(max-width: 772.98px)" title="Details" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <dl>
          <dd>
            <div class="align-left">
              <span class="bold">SSN4: </span>
              <span> {{ dataItem.lastFourSSN }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Last Name: </span>
              <span> {{ dataItem.lastName }}</span>
            </div>
          </dd>
        </dl>
      </ng-template>
    </kendo-grid-column>

    <!-- SSN COLUMN -->
    <kendo-grid-column media="(min-width: 773px)" field="lastFourSSN" class="align-center" title="SSN4" [width]="60"
      [headerClass]="{'align-center': true}">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          {{dataItem.lastFourSSN}}
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- LAST NAME -->
    <kendo-grid-column media="(min-width: 773px)" field="lastName" title="Last Name" [width]="100">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
    </kendo-grid-column>

    <!-- WARNING STATUS -->
    <kendo-grid-column media="(min-width: 773px)" field="issueCount" title="Warning Count"
      [headerStyle]="{'text-align': 'center'}" [width]="80" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          <span>{{dataItem.issueCount}}</span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- REVIEW STATUS -->
    <kendo-grid-column media="(min-width: 773px)" field="reviewCount" title="Review Count"
      [headerStyle]="{'text-align': 'center'}" [width]="80" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          <span>{{dataItem.reviewCount}}</span>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
